import React from 'react';
import { useTheme } from '../../hooks/useTheme';
import {
  SunIcon,
  MoonIcon,
  SparklesIcon,
  MailIcon,
  DownloadIcon,
  BuildingIcon,
  ShieldCheckIcon
} from './Icons';

interface HeaderProps {
  currentPath: string;
  onNavigate: (path: string) => void;
  isLiveActive?: boolean;
  onOpenSaveSession?: () => void;
}

export const Header: React.FC<HeaderProps> = ({
  currentPath,
  onNavigate,
  isLiveActive = false,
  onOpenSaveSession
}) => {
  const { isDark, toggleTheme } = useTheme();

  return (
    <header className="app-header">
      <div className="header-brand-row" style={{ display: 'flex', alignItems: 'center', gap: '0.65rem', minWidth: 0 }}>
        <a
          href="/"
          className="brand-title"
          onClick={(e) => {
            e.preventDefault();
            onNavigate('/');
          }}
        >
          <span className="brand-orb">
            <SparklesIcon size={20} active={isLiveActive} />
          </span>
          <span>Mehfil</span>
          <span
            className="urdu-script"
            style={{
              fontSize: '0.95rem',
              fontWeight: 700,
              color: 'hsl(var(--accent-gold))',
              marginLeft: '0.1rem'
            }}
          >
            محفل
          </span>
          <span className="brand-badge">Karachi AI</span>
        </a>

        {isLiveActive && (
          <div
            className="header-live-pill"
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: '0.4rem',
              padding: '0.22rem 0.6rem',
              borderRadius: '9999px',
              backgroundColor: 'hsl(var(--success) / 0.14)',
              border: 'none',
              color: 'hsl(var(--success))',
              fontSize: '0.7rem',
              fontWeight: 600,
              whiteSpace: 'nowrap',
              boxShadow: 'inset 0 1px 0 hsl(var(--success) / 0.32), 0 0 14px hsl(var(--success) / 0.22)'
            }}
          >
            <span
              style={{
                width: '7px',
                height: '7px',
                borderRadius: '9999px',
                backgroundColor: 'hsl(var(--success))',
                flexShrink: 0
              }}
            />
            <span>
              <span className="header-mobile-hide">Gemini 3.8 </span>Live<span className="header-mobile-hide"> Active</span>
            </span>
          </div>
        )}
      </div>

      <nav className="header-nav" aria-label="Platform Navigation">
        <button
          type="button"
          className={`nav-link ${currentPath === '/' ? 'active' : ''}`}
          onClick={() => onNavigate('/')}
        >
          <SparklesIcon size={15} />
          <span>Customer Concierge</span>
        </button>

        <button
          type="button"
          className={`nav-link ${currentPath === '/partner' ? 'active' : ''}`}
          onClick={() => onNavigate('/partner')}
        >
          <BuildingIcon size={15} />
          <span>Hall Owner Portal</span>
        </button>

        <button
          type="button"
          className={`nav-link ${currentPath === '/admin' ? 'active' : ''}`}
          onClick={() => onNavigate('/admin')}
        >
          <ShieldCheckIcon size={15} />
          <span>Super Admin</span>
        </button>
      </nav>

      <div className="header-actions">
        <button
          type="button"
          className="header-pill-btn"
          onClick={() => {
            if (onOpenSaveSession) {
              onOpenSaveSession();
            } else {
              window.dispatchEvent(new CustomEvent('mehfil:open-save-session'));
            }
          }}
          title="Email Magic Session Resumption Link"
        >
          <MailIcon size={14} style={{ color: 'hsl(var(--glow-gemini-blue))' }} />
          <span>
            Save<span className="header-mobile-hide"> / Email Session</span>
          </span>
        </button>

        <a
          href="/downloads/mehfil.apk"
          className="header-pill-btn"
          title="Download Native Android APK (com.intrepid.mehfil)"
        >
          <DownloadIcon size={14} style={{ color: 'hsl(var(--accent-emerald))' }} />
          <span>
            <span className="header-mobile-hide">Android </span>APK
          </span>
        </a>

        <button
          type="button"
          className="theme-toggle-btn"
          onClick={toggleTheme}
          aria-label="Toggle Theme"
          title={`Switch to ${isDark ? 'Google Porcelain Light' : 'Deep Obsidian Dark'} Mode`}
        >
          {isDark ? <SunIcon size={16} /> : <MoonIcon size={16} />}
        </button>
      </div>
    </header>
  );
};
